import { Address } from '@anyx/shared-utils';

export const LastNameDisplay = ({ address }: { address: Address; hasPrevious: boolean }) => {
  return address?.lastName ? <span>{address?.lastName}</span> : null;
};
